module.exports = "<% if(!collectionLoaded){ %>\n    <div class=\"container-fluid sw-db\">\n        <div class=\"spinner-table\">\n            <div class=\"spinner-wrapper\">\n                <div class=\"spinner-loader\">\n                    Loading…\n                </div>\n            </div>\n        </div>\n    </div>\n<% } %>\n\n";


//////////////////
// WEBPACK FOOTER
// ./srv/public/js/templates/reports/editReports/editReports.html
// module id = 1007
// module chunks = 7